import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

const ModuleContext = createContext({
  modules: [],
  hasModule: () => true,
  hasFullAccess: true,
  organisation: null,
  loading: true,
});

export function ModuleProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [modules,       setModules]       = useState([]);
  const [hasFullAccess, setHasFullAccess] = useState(true);
  const [organisation,  setOrganisation]  = useState(null);
  const [loading,       setLoading]       = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setModules([]);
      setHasFullAccess(true);
      setOrganisation(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get("/accounts/my-modules/")
      .then(res => {
        const mods = res.data.modules ?? [];
        const full = res.data.has_full_access ?? true;
        const org  = res.data.organisation ?? null;
        setModules(mods);
        setHasFullAccess(full);
        setOrganisation(org);
        console.log("ModuleContext loaded:", mods, "has_full_access:", full, "organisation:", org);
      })
      .catch(() => {
        setHasFullAccess(true); // fail open — better to show too much than hide things
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated]); // re-runs on login AND logout

  const hasModule = useCallback((moduleName) => {
    if (hasFullAccess) return true;
    return modules.includes(moduleName);
  }, [hasFullAccess, modules]);

  return (
    <ModuleContext.Provider value={{ modules, hasModule, hasFullAccess, organisation, loading }}>
      {children}
    </ModuleContext.Provider>
  );
}

export const useModules = () => useContext(ModuleContext);
